import { TimeBookingPackage } from '@thurstech/commons/dist/entity/venue';
import _ from 'lodash';
import React from 'react';
import { FieldErrors, UseFormRegister, UseFormSetValue, UseFormTrigger, UseFormWatch } from 'react-hook-form';

import Button from '../../../components/button/Button';
import Modal from '../../../components/common/Modal';
import Input from '../../../components/input/Input';
import { useAppDispatch, useAppSelector } from '../../../hooks/store';
import { successMessage } from '../../../hooks/useNotifications';
import { savePackageThunk } from '../../../redux/reducer/listingSlice';
import { AddProductsFormData } from '../../../validation/operations/addOrEditProduct/timeBooking/addProductSchemas';

interface PackageModalProps {
  index: number;
  isOpen: boolean;
  resetState: () => void;
  onClose: () => void;
  listingId: string;
  venueId?: string;
  register: UseFormRegister<AddProductsFormData>;
  errors: FieldErrors<AddProductsFormData>;
  watch: UseFormWatch<AddProductsFormData>;
  trigger: UseFormTrigger<AddProductsFormData>;
  setValue: UseFormSetValue<AddProductsFormData>;
}

const AddServiceModal: React.FC<PackageModalProps> = ({
  index,
  isOpen,
  onClose,
  listingId,
  venueId,
  resetState,
  watch,
  register,
  setValue,
  errors,
  trigger
}) => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(state => state.listing.isLoading);
  const commonProps = {
    register,
    errors,
    required: true,
    topLabel: true
  };

  const resourcesDetails = watch(`packages.${index}.resources.details`);
  const resourcesError = _.get(errors, `packages.${index}.resources`)?.message as string;
  console.log(errors);

  console.log('resourcesError', resourcesError);
  console.log('errors', errors);
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        resetState();
        onClose();
      }}
      header="Add Service"
    >
      <div className="grid grid-cols-2 gap-4">
        <Input {...commonProps} hidden name={`packages.${index}.id`} type="text" />
        <Input
          label="Title"
          name={`packages.${index}.title`}
          type="text"
          placeholder="Enter Package Title"
          {...commonProps}
        />
        <Input
          label="Price"
          name={`packages.${index}.price`}
          type="number"
          placeholder="Enter price"
          {...commonProps}
        />
        <Input
          label="Duration (in minutes)"
          name={`packages.${index}.duration`}
          type="number"
          placeholder="Enter your duration in minutes"
          {...commonProps}
        />
        <Input
          label="Discount"
          name={`packages.${index}.discount`}
          type="number"
          placeholder="Enter Discount %"
          {...commonProps}
        />
      </div>
      <div className="my-2">
        <div className=" flex justify-between mb-1 w-1/4">
          <h1 className=" text-lg font-semibold">Court Details</h1>
          <button
            onClick={async () => {
              const isValid = await trigger(`packages.${index}.resources.details`);
              if (isValid) {
                setValue(`packages.${index}.resources.details`, [...resourcesDetails, { name: '' }]);
              }
            }}
            type="button"
            className="border border-black bg-white rounded-md px-2"
          >
            +
          </button>
        </div>
        {resourcesError && <p className="text-red-600 text-sm font-semibold">{resourcesError}</p>}
      </div>
      <div className="grid grid-cols-3 gap-8">
        {(resourcesDetails ?? [{}]).map((_, resourceIndex) => (
          <div key={resourceIndex} className="flex items-center gap-2">
            <Input
              name={`packages.${index}.resources.details.${resourceIndex}.name`}
              type="text"
              placeholder="Court name"
              {...commonProps}
            />
            <Button label="X" className="px-1 mb-2" type="button" />
          </div>
        ))}
      </div>

      <div className="mt-2">
        <Button
          type="button"
          onClick={async () => {
            const isValid = await trigger([`packages`]);
            if (isValid) {
              const packageDetail = watch(`packages.${index}`);
              if (venueId) {
                const { id } = await dispatch(
                  savePackageThunk({ listingId, venueId, packageDetail: packageDetail as TimeBookingPackage })
                ).unwrap();
                if (id) {
                  setValue(`packages.${index}.id`, id);
                }
                successMessage('Successfully saved package details');
              }
              onClose();
            }
          }}
          isLoading={isLoading[savePackageThunk.pending.toString()]}
          label="Add"
          className="font-medium bg-[#35e0a1] pl-12 pt-1 mt-2 pb-1 rounded-md pr-12"
        />
      </div>
    </Modal>
  );
};

export default AddServiceModal;
